<div style="height:8px;">&nbsp;</div>
<div *ngIf="hasPlan" fxFlex="95" fxLayout="row" style="margin-bottom:4px;">
    <span aria-label="Plan Code">{{ plan }}</span>&nbsp;&bull; {{ date | date : 'M/d/yy' }}
</div>
<div fxFlex="95" fxLayout="row">
    <div fxFlex="40" fxLayout="column">
        Completed Enrollment: {{complete}}
    </div>
    <div fxFlex="40">
        Incomplete Enrollment:
        <a *ngIf="hasPlan" [href]="benefitPlanUrl">{{incomplete}}</a>
        <span *ngIf="!hasPlan">{{incomplete}}</span>
    </div>
    <div fxFlex="20" fxLayout="column">
        Total: {{total}}
    </div>
</div>

<chartjs-container [config]="chartConfig" [heightPx]="75">
</chartjs-container>
